import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import JsBarcode from 'jsbarcode';
import { membersAPI } from '../../services/api';
import { LoadingPage } from '../../components/Loading';
import { CATEGORY_LABELS } from '../../utils/membership';
import './MemberPrint.css';

const MemberPrint = () => {
  const { id } = useParams();
  const [member, setMember] = useState(null);

  useEffect(() => {
    membersAPI.getMember(id).then((response) => setMember(response.data)).catch(() => setMember(false));
  }, [id]);

  useEffect(() => {
    if (!member?.member_number) return;
    JsBarcode('#member-barcode', member.member_number, {
      format: 'CODE128',
      displayValue: true,
      height: 48,
      margin: 0,
      fontSize: 14,
    });
  }, [member]);

  if (member === null) return <LoadingPage message="載入會員卡..." />;
  if (!member) return <p>找不到會員</p>;

  return (
    <div className="print-page">
      <div className="no-print pos-actions">
        <Link to={`/admin/members/${id}`}>返回會員</Link>
        <button type="button" className="pos-btn" onClick={() => window.print()}>列印</button>
        <p>重發 QR 後，舊 QR 失效。請用最新畫面列印。</p>
      </div>
      <article className="member-sticker">
        <h1>{member.chinese_name}</h1>
        {member.english_name && <p>{member.english_name}</p>}
        <p>{CATEGORY_LABELS[member.member_category] || member.member_category}</p>
        <p className="member-sticker-number">{member.member_number}</p>
        <div className="member-sticker-codes">
          {member.qr_code_token && <QRCodeSVG value={member.qr_code_token} size={96} level="M" />}
          <svg id="member-barcode" />
        </div>
      </article>
    </div>
  );
};

export default MemberPrint;
